import Input from '../../../components/ui/Input';
import { MONO_CLASS } from '../../../components/ui/Mono';
import { FieldCell, FieldInputProps, FormSection } from '../editorParts';

/**
 * Peso e pallet. Peso vazio grava o sentinela 0,001 no servidor (pendência
 * "peso não informado"); bruto ≥ líquido.
 */
const LogisticsSection = ({ ctx }) => {
    const numberProps = { inputMode: 'decimal', autoComplete: 'off', className: MONO_CLASS };
    return (
        <FormSection
            id="logistica"
            title="Peso e pallet"
            description="O peso bruto trava endereços no armazém; pallets calculam o romaneio."
        >
            <FieldCell span={2}>
                <Input
                    label="Peso líquido"
                    suffix="kg"
                    placeholder="0,000"
                    {...numberProps}
                    {...FieldInputProps(ctx, 'weight_net_kg', { hint: 'Até 3 casas decimais' })}
                />
            </FieldCell>
            <FieldCell span={2}>
                <Input
                    label="Peso bruto"
                    suffix="kg"
                    placeholder="0,000"
                    {...numberProps}
                    {...FieldInputProps(ctx, 'weight_gross_kg', {
                        hint: 'Com embalagem; não pode ser menor que o líquido',
                    })}
                />
            </FieldCell>
            <FieldCell span={2}>
                <Input
                    label="Unidades por pallet"
                    suffix="un"
                    placeholder="Sem pallet"
                    inputMode="numeric"
                    autoComplete="off"
                    className={MONO_CLASS}
                    {...FieldInputProps(ctx, 'units_per_pallet', {
                        hint: 'Calcula os pallets do romaneio; vazio = sem pallet',
                    })}
                />
            </FieldCell>
        </FormSection>
    );
};

export default LogisticsSection;
